  <template>
    <!-- <div class="content-box"> 
      <div class="col-12">
      <div class="row">-->
      <div>
         <div v-if="dataTabla.conteod_set.length > 0" class="row">
          <div v-for="(det, index) in dataTabla.conteod_set" v-bind:key="det.id" class="col-sm-12 col-lg-12">
            <div class="borderY py-2" v-if="det.estado=='A'">
              <div class="card-body container">
                <div class="row py-3">
                  <!-- Primera columna - Información del producto -->
                  <div class="col-lg-6 col-sm-12">
                    <div class="d-flex flex-column">

                      <h5>
                        <span v-if="det.orden" class="conteo-orden mr-2">{{ det.orden }}</span>{{ det.producto.nombre }}
                      </h5>
                      <h6 class="text-muted ">{{ det.producto.sku }}</h6>
                      <small class="text-muted d-block">
                        <i class="fa fa-clock mr-1"></i>
                        Último conteo: {{ det.fecha_creacion | moment("DD/MM/YYYY HH:mm:ss") }}
                      </small>
                    </div>
                  </div>

                  <!-- Segunda columna - Unidades contadas y causal -->
                  <div v-if="tipo != 'R'" class="col-lg-12">
                    <!-- Unidades contadas -->
                      <span class="text">
                        <i class="fa fa-check-circle mr-0"></i>
                        Unidades Contadas: <b>{{ det.total }}</b>
                      </span>
                  </div>
                  <div v-if="tipo == 'R' && dataTabla.conteod_set" class="col-lg-4 col-sm-12 d-flex align-items-end">
                    <div class="label">
                      <!-- Información de causal -->
                      <div class=" badge col-lg-4 col-sm-12 d-flex align-items-start">
                        <div v-if="dataTabla.conteod_set[index].causal_obj">
                          <div v-if="dataTabla.conteod_set[index].causal_obj.causal">
                            <div class="d-flex flex-column align-items-start">
                              <span class=" d-flex align-items-center text-info medium mt-2">
                                <i class="fa fa-exclamation-circle mr-1"></i>
                                 Causal: {{ dataTabla.conteod_set[index].causal_obj.causal.nombre }}
                              </span>
                              <span class="d-flex align-items-center text-info medium mt-2">
                                <i class="fa fa-comment mr-1"></i>
                                 Motivo: {{ dataTabla.conteod_set[index].causal_obj.nombre }}
                              </span>
                            </div>
                          </div>
                          <div v-else>
                            <span class="text-info medium mt-2">
                              <i class="fa fa-exclamation-circle mr-1"></i>
                             Causal: {{ dataTabla.conteod_set[index].causal_obj.nombre }}
                            </span>
                          </div>
                        </div>
                        <div v-else>
                          <span class="text-danger medium mt-2">
                            <i class="fa fa-exclamation-circle mr-1"></i>
                             Causal: Desconocido
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Tercera columna - Fecha vencimiento y existencia -->
                  <div class="col-lg-2 col-sm-12 d-flex align-items-end">
                    <div class="d-flex flex-column">
                      <div class="mb-0">
                        <span class="medium d-block" v-if="det.fecha_vencimiento">
                        <i class="fa fa-calendar mr-1"></i>
                        Vence: {{ det.fecha_vencimiento | moment("DD/MM/YYYY") }}
                      </span>
                      <span v-if="dataTabla.fecha_finalizacion && tipo != 'R'" class="medium d-block">
                        <i class="fa fa-cubes mr-1"></i>
                        Teórica: {{ det.existencia_al_asignar }}
                      </span>
                      </div>
                    </div>
                  </div>

                  <!-- Cuarta columna - Botón eliminar -->
                  <div v-if="!bloqueado" class="col-lg-12 col-sm-12 d-flex align-items-center justify-content-end" :data-id="det.id">
                    <button class="btn btn-lg btn-danger" @click="idAnularDetalle(det.id)" >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!--</div>
    </div>
     </div> -->
  </template>
<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";

import Vue from "vue";
Vue.use(require("vue-moment"));

export default {
  components: {
    UsuarioEnTablaComponent,
    ProductoSelectComponentV2,
  },
  props: ["dataTabla", "tipo", "bloqueado"],
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      posiciones: [],
      searchtext: "",
      filtro_estado: "",
      currentDet: "",
      type: "",
      current: {
        producto: "",
        cantidad: 0,
        posicion: "",
        fecha_vencimiento: "",
      },
    };
  },
  watch: {},
  computed: {},
  mounted() {
    console.log("DATATABLE: ", this.dataTabla)
  },
  methods: {
    idAnularDetalle(id) {
      this.$emit('id-anular-detalle', id);
    }
  },
};
</script>
<style lang="css" scoped>
.borderY {
  transition: all .2s;
  border-top: solid 1px #DDD;
  border-bottom: solid 1px #DDD;
}
.borderY:hover {
  transition: all .2s;
  background-color: #e2e2e2!important;
}
</style>